<script>
  import options from './GroupPost.options'
  export default options
</script>

<template>
  <div class="kb-group-post">
    <div class="kb-group-post__contents">

      <div  class="kb-group-post__contents-left">
  
        <div v-if="!isMasked && result.author" class="kb-group-post__contents-left-top">
          <figure class="kb-image-module kb-image-module--1-1 kb-group-post__contents-left-top-profile-img">
              <button v-if="result.authorId" v-on:click="(e) => startUserInfoOverlay(e, result.authorId)">
                <div class="kb-image-module__image-container">                  
                    <picture class="kb-image-module__image">
                        <img :src="result.imageUrl" alt="ProfileImage" />
                    </picture>
                </div>
              </button>
              <div v-else class="kb-image-module__image-container">                  
                  <picture class="kb-image-module__image">
                      <img :src="result.imageUrl" alt="ProfileImage" />
                  </picture>
              </div>
          </figure>
          <button v-if="result.authorId" class="kb-group-post__contents-left-top-texts kb-group-post__contents-left-top-texts--button"
                  v-on:click="(e) => startUserInfoOverlay(e, result.authorId)"
                  v-on:keydown.enter="(e) => startUserInfoOverlay(e, result.authorId)"
                  aria-haspopup="true"
                  :aria-expanded="userInfoExpanded">
            <div class="kb-group-post__contents-left-top-post-author-data">
              <p class="kb-group-post__contents-left-top-post-author-data-name">
                {{ result.author }}
              </p>
              <div class="kb-group-post__contents-left-top-post-author-data-date-wrapper">
                <p class="kb-group-post__contents-left-top-post-author-data-date">
                  {{ result.date }}
                </p>
                <p v-if="result.edited" class="kb-group-post__contents-left-top-post-author-data-date kb-group-post__contents-left-top-post-author-data-date--edited">
                  {{ getLabel('editedLabel') }}: {{ result.edited.date }}
                  <span>{{ result.edited.author }}</span>
                </p>
              </div>
            </div>
          </button>
          <div v-else class="kb-group-post__contents-left-top-texts">
            <div class="kb-group-post__contents-left-top-post-author-data">
              <p class="kb-group-post__contents-left-top-post-author-data-name">
                {{ result.author }}
              </p>
              <div class="kb-group-post__contents-left-top-post-author-data-date-wrapper">
                <p class="kb-group-post__contents-left-top-post-author-data-date">
                  {{ result.date }}
                </p>
                <p v-if="result.edited" class="kb-group-post__contents-left-top-post-author-data-date kb-group-post__contents-left-top-post-author-data-date--edited">
                  {{ getLabel('editedLabel') }}: {{ result.edited.date }}
                  <span>{{ result.edited.author }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isMasked" class="kb-group-post__contents-left-info-locked">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 16"><path fill="#3C3C3C" fill-rule="evenodd" d="M10 3.5a3 3 0 0 0-6 0V5h.5V3.5a2.5 2.5 0 0 1 5 0v3h-9v9h11V14H11v1H1V7h12v8.5h.5v-9H10v-3ZM5.75 9.75a1.25 1.25 0 1 1 1.875 1.083l-.125.072V13h-1v-2.095l-.125-.072A1.25 1.25 0 0 1 5.75 9.75ZM7 8a1.75 1.75 0 0 0-1 3.186V13.5h2v-2.314A1.75 1.75 0 0 0 7 8Z" clip-rule="evenodd"/></svg>
          <span>{{ getLabel('notLoggedInTitle') }}</span>
        </div>
          
        <button @click="(e) => handlePostClick(e, result)" class="kb-group-post__contents-left-info">
          <h3 v-if="result.postTitle" class="kb-group-post__contents-left-info-title">{{ result.postTitle }}</h3>
          <div v-if="!result.postTitle" class="kb-group-post__contents-left-info-no-title">
            <span></span>
          </div>
          <div v-if="isMasked" class="kb-group-post__contents-left-info-no-text">
            <span></span>
            <span></span>
          </div>

          <div class="kb-group-post__contents-left-info-tags">
            <div class="kb-group-post__contents-left-info-tags-tag">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="#3C3C3C" fill-rule="evenodd" d="M10.706 8.744h.024a.649.649 0 0 0 .62-.644V1.393a.651.651 0 0 0-.651-.649H1.024a.651.651 0 0 0-.651.651v6.047h1.674v-.558H.931V1.395a.093.093 0 0 1 .093-.093H10.7a.093.093 0 0 1 .093.093V8.1a.09.09 0 0 1-.091.089H3.072C.842 8.186.373 9.45.373 10.512v.279h.558v-.28c0-1.209.68-1.767 2.14-1.767h7.635Zm4.272-3.349h-2.884v.558h2.884a.093.093 0 0 1 .093.093v5.489h-1.117v.558h1.675V6.046a.65.65 0 0 0-.651-.65Zm-4.795 7.442h2.748c2.229 0 2.698 1.265 2.698 2.326v.279h-.558v-.28c0-1.209-.68-1.767-2.14-1.767H5.296a.65.65 0 0 1-.646-.642V9.488h.558v3.26a.09.09 0 0 0 .092.09h4.883Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
              <span v-if="commentsCount !== null && commentsCount !== undefined">
                {{ commentsCount }} {{ getLabel('commentsLabel') }}
              </span>
              <span v-else class="kb-group-post__contents-left-info-tags-tag__skeleton"></span>
            </div>
          </div>
        </button>
      </div>

      <div v-if="!isMasked" class="kb-group-post__contents-right">
        <div class="kb-group-post__contents-right-top">
          <template v-if="result.hasComments">
            <h4 class="kb-group-post__contents-right-top-header">{{ getLabel('commentsTitle') }}</h4>
            <div class="kb-group-post__contents-right-top-comment">      
              <p v-if="latestComment" v-html="latestComment?.comment"></p>
              <div v-else class="kb-group-post__contents-right-top-comment__skeleton">
                <div class="kb-group-post__contents-right-top-comment__skeleton-line"></div>
                <div class="kb-group-post__contents-right-top-comment__skeleton-line"></div>
              </div>
            </div>

            <div class="kb-group-post__contents-left-top">
                <figure class="kb-image-module kb-image-module--1-1 kb-group-post__contents-left-top-profile-img">
                    <button v-if="latestComment?.authorId" v-on:click="(e) => startUserInfoOverlay(e, latestComment.authorId)">
                      <div class="kb-image-module__image-container">                      
                          <picture class="kb-image-module__image">
                              <img v-if="latestComment" :src="latestComment?.imageUrl" alt="ProfileImage" />
                              <div v-else class="kb-image-module__image-skeleton"></div>
                          </picture>
                      </div>
                    </button>
                    <div v-else class="kb-image-module__image-container">                      
                      <picture class="kb-image-module__image">
                          <img v-if="latestComment" :src="latestComment?.imageUrl" alt="ProfileImage" />
                          <div v-else class="kb-image-module__image-skeleton"></div>
                      </picture>
                    </div>
                </figure>
                <div class="kb-group-post__contents-left-top-texts">
                  <button v-if="latestComment?.authorId" class="kb-group-post__contents-left-top-post-author-data kb-group-post__contents-left-top-post-author-data--button"
                    v-on:click="(e) => startUserInfoOverlay(e, latestComment.authorId)"
                    aria-haspopup="true"
                    v-bind:aria-expanded="userInfoExpanded">
                    <p class="kb-group-post__contents-left-top-post-author-data-name">
                      <span v-if="latestComment">
                        {{ latestComment.author }}
                      </span>
                      <span v-else class="kb-group-post__contents-left-top-post-author-data__skeleton"></span>
                    </p>
                    <div class="kb-group-post__contents-left-top-post-author-data-date-wrapper">
                      <p class="kb-group-post__contents-left-top-post-author-data-date">
                        <span v-if="latestComment">
                          {{ latestComment?.date }}
                        </span>
                        <span v-else class="kb-group-post__contents-left-top-post-author-data__skeleton"></span>
                      </p>
                    </div>
                  </button>
                  <div v-else class="kb-group-post__contents-left-top-post-author-data">
                    <p class="kb-group-post__contents-left-top-post-author-data-name">
                      <span v-if="latestComment">
                        {{ latestComment.author }}
                      </span>
                      <span v-else class="kb-group-post__contents-left-top-post-author-data__skeleton"></span>
                    </p>
                    <div class="kb-group-post__contents-left-top-post-author-data-date-wrapper">
                      <p class="kb-group-post__contents-left-top-post-author-data-date">
                        <span v-if="latestComment">
                          {{ latestComment?.date }}
                        </span>
                        <span v-else class="kb-group-post__contents-left-top-post-author-data__skeleton"></span>
                      </p>
                    </div>
                  </div>
                </div>
            </div>
          </template>
          <template v-else>
            <h4 class="kb-group-post__contents-right-top-header">{{ getLabel('noCommentsTitle') }}</h4>
            <div class="kb-group-post__contents-right-top-comment">
              <p>{{ getLabel('noCommentsDesc') }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
